import React, { useState, useEffect, useCallback } from 'react';
import HeroSlide from './HeroSlide';
import { trackSliderInteraction } from '../utils/analytics';

const HeroSlider = ({ slides }) => {
  const total = slides.length;
  // 末尾に先頭スライドを複製し、右方向への継ぎ目ないループを実現
  const slidesEx = [...slides, slides[0]];

  const [index, setIndex] = useState(0);
  const [anim, setAnim] = useState(true);

  // 次のスライドへ（右へ）
  const nextSlide = useCallback(() => {
    setAnim(true);
    setIndex((prev) => prev + 1);
  }, []);

  // 前のスライドへ
  const prevSlide = useCallback(() => {
    setAnim(true);
    setIndex((prev) => (prev <= 0 ? total - 1 : prev - 1));
  }, [total]);

  // 自動スライド（常時ON・6秒ごと・右へ無限ループ）
  useEffect(() => {
    const interval = setInterval(() => {
      setAnim(true);
      setIndex((prev) => prev + 1);
    }, 6000);

    return () => clearInterval(interval);
  }, []);

  // 複製スライドに到達したら、アニメ無しで先頭へ瞬間リセット
  const handleTransitionEnd = () => {
    if (index >= total) {
      setAnim(false);
      setIndex(0);
    }
  };

  // リセット後、次フレームでアニメを再有効化
  useEffect(() => {
    if (!anim) {
      const raf = requestAnimationFrame(() => {
        requestAnimationFrame(() => setAnim(true));
      });
      return () => cancelAnimationFrame(raf);
    }
  }, [anim]);

  const styles = {
    sliderWrapper: {
      display: 'flex',
      flexDirection: 'column',
    },
    sliderContainer: {
      position: 'relative',
      width: '100%',
      height: '100vh',
      overflow: 'hidden',
      background: '#ffffff',
    },
    slidesWrapper: {
      position: 'relative',
      width: '100%',
      height: '100%',
    },
    navigationButton: {
      position: 'absolute',
      top: '50%',
      transform: 'translateY(-50%)',
      background: 'rgba(255, 255, 255, 0.3)',
      border: '2px solid rgba(255, 255, 255, 0.5)',
      color: '#ffffff',
      width: '50px',
      height: '50px',
      borderRadius: '50%',
      cursor: 'pointer',
      fontSize: '24px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      zIndex: 40,
      transition: 'all 0.3s',
      backdropFilter: 'blur(5px)',
    },
    prevButton: {
      left: '30px',
    },
    nextButton: {
      right: '30px',
    },
  };

  return (
    <div style={styles.sliderWrapper}>
      <style>
        {`
          @media (max-width: 768px) {
            .nav-button-mobile {
              width: 40px !important;
              height: 40px !important;
              font-size: 18px !important;
            }
            .prev-button-mobile {
              left: 15px !important;
            }
            .next-button-mobile {
              right: 15px !important;
            }
            h1 {
              font-size: 38px !important;
            }
            h3 {
              font-size: 24px !important;
            }
            .slider-Container {
              height: 60vh !important;
            }
          }
        `}
      </style>

      {/* スライド表示エリア */}
      <div style={styles.sliderContainer} className="slider-Container">
        <div style={styles.slidesWrapper}>
          <div
            onTransitionEnd={handleTransitionEnd}
            style={{
              display: 'flex',
              width: '100%',
              height: '100%',
              transform: `translateX(-${index * 100}%)`,
              transition: anim ? 'transform 0.8s cubic-bezier(0.65, 0, 0.35, 1)' : 'none',
            }}
          >
            {slidesEx.map((slide, i) => (
              <HeroSlide
                key={`${slide.id}-${i}`}
                slideData={slide}
                isActive={i === index}
              />
            ))}
          </div>
        </div>

        {/* 前へボタン */}
        <button
          onClick={() => {
            prevSlide();
            // Analytics追跡
            trackSliderInteraction('prev', index);
          }}
          style={{ ...styles.navigationButton, ...styles.prevButton }}
          className="nav-button-mobile prev-button-mobile"
          onMouseEnter={(e) => {
            e.currentTarget.style.background = 'rgba(255, 255, 255, 0.5)';
            e.currentTarget.style.transform = 'translateY(-50%) scale(1.1)';
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.background = 'rgba(255, 255, 255, 0.3)';
            e.currentTarget.style.transform = 'translateY(-50%) scale(1)';
          }}
        >
          ‹
        </button>

        {/* 次へボタン */}
        <button
          onClick={() => {
            nextSlide();
            // Analytics追跡
            trackSliderInteraction('next', index);
          }}
          style={{ ...styles.navigationButton, ...styles.nextButton }}
          className="nav-button-mobile next-button-mobile"
          onMouseEnter={(e) => {
            e.currentTarget.style.background = 'rgba(255, 255, 255, 0.5)';
            e.currentTarget.style.transform = 'translateY(-50%) scale(1.1)';
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.background = 'rgba(255, 255, 255, 0.3)';
            e.currentTarget.style.transform = 'translateY(-50%) scale(1)';
          }}
        >
          ›
        </button>
      </div>

    </div>
  );
};

export default HeroSlider;